export default "__VITE_ASSET__CvUKRAex__"